













































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { RedCapital, SelectedCountry, TitleTemplatePublic } from '@/configuration'

@Component({
	metaInfo: {
		title: 'Protocolo de cobranza',
		titleTemplate: TitleTemplatePublic,
		htmlAttrs: {
			// @ts-ignore
			lang: RedCapital[SelectedCountry].Lang,
		}
	},
})
export default class Faq extends Vue {}
